import {
  CreateCampaignModal as CreateCampaign,
  CreateCampaignFormProvider,
} from 'modules/campaignIndex/modals/CreateCampaignModal';
import { RumComponentContextProvider } from 'services/observability/datadog';
import { Product, Team } from 'teams';

type CreateCampaignModalProps = {
  onClose: () => void;
};

export const CreateCampaignModal = ({ onClose }: CreateCampaignModalProps) => {
  return (
    <RumComponentContextProvider
      componentName="QuickActions/CreateCampaignModal"
      productName={Product.CAMPAIGN_INDEX}
      teamName={Team.CAMPAIGN_TEAM}
    >
      <CreateCampaignFormProvider>
        <CreateCampaign onClose={onClose} />
      </CreateCampaignFormProvider>
    </RumComponentContextProvider>
  );
};
